/**
*
* TextArea
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import Hint from 'components/Hint';
import Label from 'components/Label';
import CharacterCounter from 'components/CharacterCounter';

import InputContentWrapper from 'components/Input/styles/InputContentWrapper';
import InputErrorContent from 'components/Input/styles/InputErrorContent';
import InputHeader from 'components/Input/styles/InputHeader';
import InputRequireContent from 'components/Input/styles/InputRequireContent';

import TextAreaWrapper from './styles/TextAreaWrapper';
import InputHintRequireWrapper from '../Input/styles/InputHintRequireWrapper';
import InputHintContent from '../Input/styles/InputHintContent';

export class TextArea extends React.Component {

  constructor() {
    super();
    this.handleOnChange = this.handleOnChange.bind(this);

    this.state = {
      isTooLong: false
    };
  }

  handleOnChange(event) {

    const {
      maxLength
    } = this.props;

    const hasValue = event && event.target && event.target.value;
    const isTooLong = (hasValue && event.target.value.length > 10000) || (maxLength && hasValue && event.target.value.length > maxLength);

    if (isTooLong)  {
      this.setState({
        isTooLong: true
      });
    } else {
      if (this.state.isTooLong) this.setState({
        isTooLong: false
      });
    }


    if (this.props.onChange) {
      if (this.props.type === 'file') {
        return this.props.onChange(event);
      } else if (this.props.updateType) {
        return this.props.onChange({
          value: event.target.value,
          updateType: this.props.updateType,
          language: this.props.language,
          type: this.props.type
        });
      } else if (this.props.passEvent) {
        return this.props.onChange(event);
      } else {
        return this.props.onChange(event.target.value);
      }
    }

    return null;

  }

  render() {

    const {
      value,
      label,
      thisStyles,
      error,
      hint,
      required,
      labelStyles,
      thisStylesInputHeader,
      maxLength = 500,
      language,
      labelStylesCss,
      placeholderStylesCss,
      counterStyles
    } = this.props;

    const { isTooLong } = this.state;

    const thisError = isTooLong || error;


    const errorContent = thisError || isTooLong ? <InputErrorContent>{isTooLong ? 'Too many characters!' : thisError.statusText ? thisError.statusText : thisError && thisError[language] && thisError[language].statusText ? thisError[language].statusText : thisError[language] === 'string' ? thisError && thisError[language] : typeof thisError === 'string' ? thisError : 'Something is wrong...'}</InputErrorContent> : '';

    const hintContent = hint ? (
      <InputHintContent>
        <Hint message={hint} />
      </InputHintContent>
    ) : (
        ''
      );

    const requiredCondition = (required && !thisError) || (required && thisError) === ' '; 
    const requireContent = requiredCondition
      ? <InputRequireContent>required</InputRequireContent>
      : '';

    const labelContent = label ? (
      <Label
        title={label}
        thisStyles={{
          marginBottom: '1rem',
          marginTop: '3rem',
          flex: 'none',
          ...labelStyles,
        }}
        labelStylesCss={labelStylesCss}
      />
    ) : '';

    return (
      <InputContentWrapper>
        <InputHeader thisStyles={thisStylesInputHeader}>
          <InputHintRequireWrapper isRequired={requiredCondition}>
            {requireContent}
            {hintContent}
          </InputHintRequireWrapper>
          {labelContent}
        </InputHeader>
        <TextAreaWrapper
          value={value}
          onChange={this.handleOnChange}
          thisStyles={thisStyles}
          error={thisError ? true : false}
          placeholderStylesCss={placeholderStylesCss}
        >
        </TextAreaWrapper>
        {errorContent}
        {!maxLength || isTooLong ? '' : (
          <CharacterCounter
            characterNum={value ? value.length : null}
            maxCharacters={maxLength}
            thisStyles={counterStyles}
          />
        )}
      </InputContentWrapper>
    );
  }

}
TextArea.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  updateType: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  thisStyles: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  maxLength: PropTypes.number,
  error: PropTypes.string,
  hint: PropTypes.shape({
    body: PropTypes.string,
    title: PropTypes.string
  }),
  required: PropTypes.bool,
  labelStyles: PropTypes.object,
  thisStylesInputHeader: PropTypes.object,
};

export default TextArea;
